import { useTheme } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";
import InitiativeCard from "./InitiativeCard";
import { useLookupColorMaps } from "../hooks/useLookups";

export default function BoardColumn({
  horizon,
  initiatives,
  isDragOver,
  onDragOver,
  onDragLeave,
  onDrop,
  onCardClick,
  canDrag,
}) {
  const theme = useTheme();
  const { horizonColors } = useLookupColorMaps();

  const styles = {
    column: {
      flex: "1 1 0",
      minWidth: 260,
      bgcolor: "background.tableBody",
      borderRadius: 1,
      overflow: "hidden",
    },
    columnHeader: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      px: 2,
      py: 1,
      bgcolor: "background.tableHeader",
      color: "background.tableHeaderText",
      fontWeight: 700,
      fontSize: "0.7rem",
      textTransform: "uppercase",
      letterSpacing: "0.07em",
      borderTop: 3,
    },
    columnCount: { fontWeight: 700, fontSize: "0.7rem", flexShrink: 0 },
    cardStack: {
      p: 1.5,
      display: "flex",
      flexDirection: "column",
      gap: 1.5,
      minHeight: 80,
    },
    columnDragOver: {
      outline: `2px dashed ${theme.palette.primary.main}`,
      outlineOffset: -2,
    },
    columnTitle: {
      fontWeight: "inherit",
      pr: 1,
      minWidth: 0,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
  };

  return (
    <Box
      sx={[styles.column, isDragOver ? styles.columnDragOver : null]}
      onDragOver={canDrag ? onDragOver : undefined}
      onDragLeave={canDrag ? onDragLeave : undefined}
      onDrop={canDrag ? onDrop : undefined}
    >
      <Box
        sx={[
          styles.columnHeader,
          { borderColor: horizonColors[horizon] || "primary.main" },
        ]}
      >
        <Typography component="span" sx={styles.columnTitle}>
          {horizon}
        </Typography>
        <Typography component="span" sx={styles.columnCount}>
          {initiatives.length}
        </Typography>
      </Box>
      <Box sx={styles.cardStack}>
        {initiatives.map((initiative) => (
          <InitiativeCard
            key={initiative.id}
            initiative={initiative}
            onClick={onCardClick}
            draggable={canDrag}
          />
        ))}
      </Box>
    </Box>
  );
}
